import React from 'react';
import PropTypes from 'prop-types';

export const DottedLineXs = ({ className }) => (
  <svg className={className} width="4" height="26" viewBox="0 0 4 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path d="M2 0L2.00004 869" stroke="#FDAE39" strokeWidth="4" strokeDasharray="2 2" />
    </g>
  </svg>
);

DottedLineXs.propTypes = {
  className: PropTypes.string,
};

DottedLineXs.defaultProps = {
  className: '',
};

